import ContentLoader from "react-content-loader";
import { HideMobile } from "../../../../02-atoms/06-layout/02-visibility/02-hide-mobile";
import { HideDesktop } from "../../../../02-atoms/06-layout/02-visibility/01-hide-desktop";

/**
 * Responsive placeholder skeleton for resume teaser when page is loading.
 * Uses percentage-based widths and responsive positioning.
 */
export const ResumeTeaserPlaceholder = () => (
  <>
    <HideMobile>
      <ContentLoader
        height={120}
        width="100%"
        speed={2}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        uniqueKey="resume-teaser"
        style={{ maxWidth: "800px", margin: "0 auto" }}
      >
        <rect x="15%" y="1" rx="3" ry="3" width="40%" height="13" />
        <rect x="15%" y="30" rx="3" ry="3" width="70%" height="10" />
        <rect x="15%" y="54" rx="3" ry="3" width="75%" height="10" />
        <rect x="15%" y="74" rx="3" ry="3" width="40%" height="10" />
        <circle cx="7%" cy="36" r="30" />
      </ContentLoader>
    </HideMobile>
    <HideDesktop>
      <ContentLoader
        height={130}
        width="100%"
        speed={2}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        uniqueKey="resume-teaser-mobile"
        style={{ maxWidth: "400px", margin: "0 auto" }}
      >
        <circle cx="38" cy="36" r="30" />
        <rect x="0" y="80" rx="3" ry="3" width="70%" height="10" />
        <rect x="0" y="100" rx="3" ry="3" width="75%" height="10" />
        <rect x="0" y="120" rx="3" ry="3" width="40%" height="10" />
      </ContentLoader>
    </HideDesktop>
  </>
);
